<template>
  <div class="login-container" :style="{ 'background-image': 'url(' + loginBgImage + ')' }">
    <div class="login-box">
      <el-form ref="modPassForm"
               :model="modPassForm"
               :rules="modPassRules"
               class="login-form"
               auto-complete="on"
               label-position="left">
        <el-form-item>
          <h2 class="title">
            修改密码
          </h2>
          <h3 class="title">
            {{ title || "AiBEE 盘古标注平台" }}
          </h3>
        </el-form-item>
        <el-form-item prop="oldPassword">
          <el-input v-model="modPassForm.oldPassword"
                    type="password"
                    name="oldPassword"
                    placeholder="请输入旧密码" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="modPassForm.password"
                    type="password"
                    name="password"
                    placeholder="请输入新密码" />
        </el-form-item>
        <el-form-item prop="passConfirm">
          <el-input v-model="modPassForm.passConfirm"
                    type="password"
                    name="passConfirm"
                    placeholder="请再次输入新密码"
                    @keyup.enter.native="handleModify" />
        </el-form-item>
        <el-form-item style="margin-top: 20px;">
          <el-button :loading="loading"
                     type="primary"
                     round
                     style="width:50%;"
                     @click.native.prevent="handleModify">
            确认修改
          </el-button>
          <el-button type="text" @click="$router.go(-1)">
            取消修改
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Cookies from 'js-cookie';
import systemConfig from '@/config';
import { modifyPassword } from '@/api/login';

export default {
  name: 'Login',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value && !/^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-z0-9A-Z]).{6,16}$/.test(value)) {
        callback(new Error('6-16 位由数字字母（大小写都有）和特殊符号组成'));
      } else {
        if (this.modPassForm.passConfirm !== '') {
          this.$refs.modPassForm.validateField('passConfirm');
        }
        callback();
      }
    };
    const validatePassConfirm = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.modPassForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      modPassForm: {
        oldPassword: '',
        password: '',
        passConfirm: '',
      },
      modPassRules: {
        oldPassword: [{ required: true, message: '旧密码不能为空' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' },
        ],
        passConfirm: [{ validator: validatePassConfirm, trigger: 'blur' }],
      },
      title: systemConfig.title,
      loginBgImage: null,
      loading: false,
      redirect: undefined,
    };
  },
  computed: {
    ...mapGetters(['theme', 'userId']),
  },
  watch: {
    $route: {
      handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  created() {
    // eslint-disable-next-line
    this.loginBgImage = require(`../../assets/login-${this.theme}.png`);
  },
  methods: {
    handleModify() {
      this.$refs.modPassForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          modifyPassword(this.userId || Cookies.get('user_id'), this.modPassForm.oldPassword, this.modPassForm.password)
            .then((res) => {
              this.loading = false;
              if (res.error_no === 0) {
                delete this.$route.query.redirect;
                this.$router.push({ path: this.redirect || '/', query: this.$route.query });
                this.$message({
                  type: 'success',
                  message: res.error_msg || '修改密码成功',
                });
              } else {
                this.$message({
                  type: 'warning',
                  message: res.error_msg || '修改密码失败',
                });
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log('error submit!!');
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.verify-code {
  img {
    margin-left: 20px;
    display: inline-block;
    vertical-align: middle;
    max-height: 50px;
  }
}
</style>
